import { requestsClient } from './apollo';

export const initUploadMutation = async () => {
  const { initUploadSession } = await requestsClient.initUploadSession();
  return initUploadSession;
};
